export const paginationMixin = {
  data: () => ({
    pagination: {
      currentPage: 1,
      perPage: 10,
      perPageList: [
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
      totalRows: 0,
    }
  }),
  computed: {
    paginationFirstRecord () {
      let firstRecord = this.pagination.perPage * (this.pagination.currentPage - 1) + 1
      return firstRecord > this.pagination.totalRows
        ? this.pagination.totalRows
        : firstRecord || this.pagination.totalRows
    },
    paginationLastRecord () {
      let lastRecord = this.pagination.currentPage * this.pagination.perPage
      return lastRecord > this.pagination.totalRows
        ? this.pagination.totalRows
        : lastRecord || this.pagination.totalRows
    }
  },
  methods: {
    paginationReset (rows) {
      this.pagination.currentPage = 1
      this.pagination.totalRows = rows.length || this.pagination.totalRows || 0
    },
  },

  watch: {
    "pagination.perPage": function(val) {
      this.paginationReset([])
    }
  }
}
